import React from 'react';
import { Formik } from 'formik';
import { VALIDATION } from 'helpers/constants';
import { useStore } from 'hooks';
import { EmailService } from 'services';
import { SendEmail } from 'components/profile';
import * as Yup from 'yup';

const SendEmailColumnValidationSchema = Yup.object().shape({
  subject: Yup.string()
    .required(...VALIDATION.REQUIRED),
  text: Yup.string()
    .required(...VALIDATION.REQUIRED),
});

const SendEmailColumn = () => {
  const { setLoading, setUser } = useStore();
  const initialValues = {
    subject: '',
    text: '',
  };

  const onSubmit = async (values) => {
    const emailService = new EmailService({ setUser });
    setLoading(true);
    await emailService.sendEmailsToAll({ ...values });
    setLoading(false);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={SendEmailColumnValidationSchema}
      onSubmit={onSubmit}
    >
      {({ handleSubmit, isValid }) => (
        <SendEmail onSubmit={handleSubmit} isValid={isValid} />
      )}
    </Formik>
  );
};

export default SendEmailColumn;
